module.exports = __webpack_public_path__ + "static/media/bg26.b5a24612.jpg";